var _defineProperty = require("/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var integration = require('../integration.js');
var cookie = require('../utils/cookie.js');
var getIpAddress = require('../vendor/getIpAddress.js');

// TODO(v10): Change defaults based on `sendDefaultPii`
var DEFAULT_INCLUDE = {
  cookies: true,
  data: true,
  headers: true,
  query_string: true,
  url: true
};
var INTEGRATION_NAME = 'RequestData';
var _requestDataIntegration = function _requestDataIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var include = _objectSpread(_objectSpread({}, DEFAULT_INCLUDE), options.include);
  return {
    name: INTEGRATION_NAME,
    processEvent: function processEvent(event, _hint, client) {
      var _include$ip;
      var _event$sdkProcessingM = event.sdkProcessingMetadata,
        sdkProcessingMetadata = _event$sdkProcessingM === void 0 ? {} : _event$sdkProcessingM;
      var normalizedRequest = sdkProcessingMetadata.normalizedRequest,
        ipAddress = sdkProcessingMetadata.ipAddress;
      var includeWithDefaultPiiApplied = _objectSpread(_objectSpread({}, include), {}, {
        ip: (_include$ip = include.ip) !== null && _include$ip !== void 0 ? _include$ip : client.getOptions().sendDefaultPii
      });
      if (normalizedRequest) {
        addNormalizedRequestDataToEvent(event, normalizedRequest, {
          ipAddress: ipAddress
        }, includeWithDefaultPiiApplied);
      }
      return event;
    }
  };
};

/**
 * Add data about a request to an event. Primarily for use in Node-based SDKs, but included in `@sentry/core`
 * so it can be used in cross-platform SDKs like `@sentry/nextjs`.
 */
var requestDataIntegration = integration.defineIntegration(_requestDataIntegration);

/**
 * Add already normalized request data to an event.
 * This mutates the passed in event.
 */
function addNormalizedRequestDataToEvent(event, req,
// Data that should not go into `event.request` but is somehow related to requests
additionalData, include) {
  event.request = _objectSpread(_objectSpread({}, event.request), extractNormalizedRequestData(req, include));
  if (include.ip) {
    var ip = req.headers && getIpAddress.getClientIPAddress(req.headers) || additionalData.ipAddress;
    if (ip) {
      event.user = _objectSpread(_objectSpread({}, event.user), {}, {
        ip_address: ip
      });
    }
  }
}
function extractNormalizedRequestData(normalizedRequest, include) {
  var requestData = {};
  var headers = _objectSpread({}, normalizedRequest.headers);
  if (include.headers) {
    requestData.headers = headers;

    // Remove the Cookie header in case cookie data should not be included in the event
    if (!include.cookies) {
      delete headers.cookie;
    }

    // Remove IP headers in case IP data should not be included in the event
    if (!include.ip) {
      getIpAddress.ipHeaderNames.forEach(function (ipHeaderName) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete headers[ipHeaderName];
      });
    }
  }
  requestData.method = normalizedRequest.method;
  if (include.url) {
    requestData.url = normalizedRequest.url;
  }
  if (include.cookies) {
    var cookies = normalizedRequest.cookies || (headers !== null && headers !== void 0 && headers.cookie ? cookie.parseCookie(headers.cookie) : undefined);
    requestData.cookies = cookies || {};
  }
  if (include.query_string) {
    requestData.query_string = normalizedRequest.query_string;
  }
  if (include.data) {
    requestData.data = normalizedRequest.data;
  }
  return requestData;
}
exports.requestDataIntegration = requestDataIntegration;